export default {"src":"/_next/static/media/Close Icon.b99aaae5.svg","height":17,"width":17};